import { getLS } from "../../../../utils/useLS";
import { createStateContext } from "react-use";
import React, { useEffect } from "react";
import { useState } from "react";
import { colors, Divider, Paper } from "@material-ui/core";
import { GroupSelectRest } from "./GroupSelectRest";
import RestItemsG from "../InvoiceRest/RestItemsG";
import axios from "axios";
import { uri } from "../../../../help/Api";
import { sto } from "../../../../Context/InshData";

export const [useSharedGroupId, SharedGroupIdProvider] = createStateContext(-1);

export function ProductsGroups(props) {
  const { dataTable, groups, groupsSub, permistionInv, valueSafes, localCasheItems, setLocalCasheItems } = props;

  const locSto = getLS("sto", {});
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [groupId, setGroupId] = useState(-1);

  const [subGroupId, setSubGroupId] = useState(-1);
  const [GroupColor, setGroupColor] = useState({});
  const [group, setGroup] = useState({});

  const [subGroups, setSubGroups] = useState([]);

  const onRowClick = (row) => {
    setGroupId(row.id);
    setGroupId(row.id);
    setGroupColor({ ...row, color: colors.blue[300] });
    setSubGroups([]);

    const subs = groupsSub?.filter((g) => g.parentId == row.id);
    setSubGroups(subs);
    setGroup(row);

    if (subs?.length > 0) {
      setSubGroupId(subs[0]?.id);
      setGroup(row);
    }
    else {
      setSubGroupId(row.id);
      setGroup(row);
    }
    viewHandle(row.id);
  };
  const onRowClickSub = (row) => {
    setGroupId(row.id);
    setGroupId(row.id);
    let clickColor = 8421504;
    setGroupColor({ ...row, color: colors.blue[300] });
    setSubGroupId(row.id);
    setGroup(row);
    viewHandle(row.id);

  };
  const viewHandle = async (group_id) => {
    setData([]);
    setLoading(true);
    const newItem = localCasheItems.find((obj) => obj.group_id.toString() === group_id.toString());
    if (newItem) {
      setData(newItem?.items);
      setLoading(false);
    } else {
      viewHandleSearch(group_id);
    }
  };

  const viewHandleSearch = async (group_id) => {
    setData([]);
    setLoading(true);
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `RptSafes/ItemsSearch?currShow=${"D"}&&curr_type=${-1}&&groupid=${group_id}
            &&take=${100}&&item_code=${''}&&item_name=${''}&&emp=${sto.empi}`
    } else {
      Urls = `RptSafes/ItemsSearch?currShow=${"D"}&&curr_type=${-1}&&groupid=${group_id}
            &&take=${100}&&item_code=${''}&&item_name=${''}&&emp=${sto.empi}&&db_name=${sto.db_name}`
    }
    await axios
      .get(
        uri + Urls
      )
      .then((res) => {
        const dataItems = res.data.map((row, i) => {
          return {
            ...row,
            val1: 1,
            val: 0,

          };
        });
        const newItem = localCasheItems.find((obj) => obj.group_id.toString() === group_id.toString());
        if (!newItem) {
          const addNewItem = { group_id: group_id, items: dataItems }
          setLocalCasheItems([...localCasheItems, addNewItem]);
        }
        setData(dataItems);
        setLoading(false);
        // setIsSearch(false);
      })
      .catch((err) => {
        setLoading(false);
        setData([]);
      });

  };
  return (
    <React.Fragment>
      <Paper
        style={{
          // backgroundColor: colors.green[50],
          maxHeight: 500,
          overflow: "auto",
        }}
      >
        <SharedGroupIdProvider>

          <GroupSelectRest
            groups={[...groups]}
            onRowClick={onRowClick}
            isMain={true}
            GroupColor={GroupColor}

          />
          <Divider />
          {subGroups.length > 0 && (
            <GroupSelectRest
              groups={[...subGroups]}
              onRowClick={onRowClickSub}
              isMain={false}
              GroupColor={GroupColor}

            />
          )}

          <RestItemsG
            onSelectItem={props.onSelectItem}
            values={dataTable ?? []}
            groupId={subGroupId}
            BefrowDataCurrencie={null}
            group={group}
            data={data ? data : []}
            loading={loading}
          />
        </SharedGroupIdProvider>
      </Paper>

      {/* <Swipeable /> */}
    </React.Fragment>
  );
}
